import {
    postWorkBatchRequest,
    postWorkBatchSuccess,
    postWorkBatchFailed,
    matchWorkBatchRequest,
    matchWorkBatchSuccess,
    matchWorkBatchFailed,
    postProductBatchRequest,
    postProductBatchSuccess,
    postProductBatchFailed,
    matchProductBatchRequest,
    matchProductBatchSuccess,
    matchProductBatchFailed,
    postAgreementBatchRequest,
    postAgreementBatchSuccess,
    postAgreementBatchFailed,
    postAdjustmentBatchRequest,
    postAdjustmentBatchSuccess,
    postAdjustmentBatchFailed,
    allocateDistributionPoolsRequest,
    allocateDistributionPoolsSuccess,
    allocateDistributionPoolsFailure,
    exportDistributionPoolsRequest,
    exportDistributionPoolsSuccess,
    exportDistributionPoolsFailure,
    triggerManualClaimJobSuccess,
    triggerManualClaimJobFailure,
    triggerManualClaimJobRequest,
    runQAOnDistributionPoolsRequest,
    runQAOnDistributionPoolsFailure,
    runQAOnDistributionPoolsSuccess,
    updateScheduledJobField, preAllocateDistributionPoolsFailure, preAllocateDistributionPoolsSuccess
} from "../reducers/RepertoireReducer";
import { ThunkAction } from "redux-thunk";
import { Action, Dispatch } from "redux";
import IAppState from "../types/IAppState";
import { JobService } from "../services/JobService";
import { IDistributionState } from "../types/IDistributionState";
import { DistributionDetailsMapper } from "../../repertoire/services/DistributionDetailsMapper";
import { ITriggerManualJob } from "../types/ITriggerManualJob";
import { IScheduledJobState } from "../types/IScheduledJobState";
import { hideModal } from "../reducers/ModalReducer";

export const postWorkBatchThunk = (workBatchID: number): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(postWorkBatchRequest(workBatchID));
        JobService.postWorkBatch(workBatchID)
            .then(res => {
                res.status === 200 ? dispatch(postWorkBatchSuccess()) : dispatch(postWorkBatchFailed());
            })
            .catch((error: any) => {
                dispatch(postWorkBatchFailed());
            })
    };
}

export const matchWorkBatchThunk = (workBatchID: number): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(matchWorkBatchRequest(workBatchID));
        JobService.matchWorkBatch(workBatchID)
            .then(res => {
                res.status === 200 ? dispatch(matchWorkBatchSuccess()) : dispatch(matchWorkBatchFailed());
            })
            .catch((error: any) => {
                dispatch(postWorkBatchFailed());
            })
    };
}

export const postProductBatchThunk = (productBatchID: number): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(postProductBatchRequest(productBatchID));
        JobService.postProductBatch(productBatchID)
            .then(res => {
                res.status === 200 ? dispatch(postProductBatchSuccess()) : dispatch(postProductBatchFailed());
            })
            .catch((error: any) => {
                dispatch(postProductBatchFailed());
            })
    };
}

export const matchProductBatchThunk = (productBatchID: number): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(matchProductBatchRequest(productBatchID));
        JobService.matchProductBatch(productBatchID)
            .then(res => {
                res.status === 200 ? dispatch(matchProductBatchSuccess()) : dispatch(matchProductBatchFailed());
            })
            .catch((error: any) => {
                dispatch(postProductBatchFailed());
            })
    };
}

export const postAgreementBatchThunk = (agreementBatchID: number): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(postAgreementBatchRequest(agreementBatchID));
        JobService.postAgreementBatch(agreementBatchID)
            .then(res => {
                res.status === 200 ? dispatch(postAgreementBatchSuccess()) : dispatch(postAgreementBatchFailed());
            })
            .catch((error: any) => {
                dispatch(postAgreementBatchFailed());
            })
    };
}

export const postAdjustmentBatchThunk = (adjustmentBatchID: number): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(postAdjustmentBatchRequest(adjustmentBatchID));
        JobService.postAdjustmentBatch(adjustmentBatchID)
            .then(res => {
                if (res.status === 200) {
                    dispatch(postAdjustmentBatchSuccess());
                } else {
                    dispatch(postAdjustmentBatchFailed());
                }
            })
            .catch((error: any) => {
                if (error?.response?.status === 409) {
                    const data = error?.response?.data;
                    let message: string | undefined;
                    if (typeof data === "string") {
                        try {
                            const parsed = JSON.parse(data);
                            message = parsed.message || parsed.error || data;
                        } catch {
                            message = data;
                        }
                    } else if (data?.message || data?.error) {
                        message = data.message || data.error;
                    }
                    dispatch(postAdjustmentBatchFailed({ conflict: true, message }));
                } else {
                    dispatch(postAdjustmentBatchFailed());
                }
            })
    };
}

export const allocateDistributionPoolsThunk = (distribution: IDistributionState, undoAllocation: boolean): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(allocateDistributionPoolsRequest())
        var distributionModel = DistributionDetailsMapper.mapStateToDistribution(distribution, true)
        JobService.allocateDistributionPools(distributionModel, undoAllocation)
            .then((res) => {
                if (res.status !== 200 || !res.data.success)
                    dispatch(allocateDistributionPoolsFailure(res.data));
                else
                    dispatch(allocateDistributionPoolsSuccess(res.data,undoAllocation));
            })
            .catch(err => {
                const apiError = err?.response?.data
                    ? err.response.data
                    : { success: false, messages: ["An unexpected error occurred."] };

                dispatch(allocateDistributionPoolsFailure(apiError));
            })
    }
}

export const preAllocateDistributionPoolsThunk = (distribution: IDistributionState, undoPreAllocation: boolean): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(allocateDistributionPoolsRequest())
        var distributionModel = DistributionDetailsMapper.mapStateToDistribution(distribution, true)
        JobService.preAllocateDistributionPools(distributionModel, undoPreAllocation)
            .then((res) => {
                if (res.status !== 200 || !res.data.success)
                    dispatch(preAllocateDistributionPoolsFailure(res.data));
                else
                    dispatch(preAllocateDistributionPoolsSuccess(res.data));
            })
            .catch(err => {
                dispatch(preAllocateDistributionPoolsFailure(err));
            })
    }
}

export const triggerManualClaimJob = (
    manualJob: ITriggerManualJob
): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(triggerManualClaimJobRequest())
        return JobService.triggerManualJob(manualJob)
            .then((res: any[]) => {
                dispatch(triggerManualClaimJobSuccess());
            })
            .catch((error: any) => {
                dispatch(triggerManualClaimJobFailure(error));
            });
    }
}

const validationErrorsFromResponse = (err: any): string[] | undefined => {
    const data = err?.response?.data;
    const errorList = data?.errorList ?? data?.ErrorList;
    return Array.isArray(errorList) && errorList.length > 0 ? errorList : undefined;
}

export const upsertScheduledJobThunk = (schedule: IScheduledJobState, componentName?: string): ThunkAction<Promise<void>, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        return JobService.upsertScheduledJob(schedule)
            .then((sch: IScheduledJobState) => {
                const errorList = sch?.errorList ?? [];
                if (errorList.length === 0) {
                    dispatch(hideModal());
                }
                dispatch(updateScheduledJobField(errorList, "errorList", componentName));
            })
            .catch(err => {
                const errorList = validationErrorsFromResponse(err);
                if (errorList) {
                    dispatch(updateScheduledJobField(errorList, "errorList", componentName));
                    return;
                }
                dispatch(hideModal());
            });
    }
}

export const runQAOnDistributionPoolsThunk = (distribution: IDistributionState, undoAllocation: boolean): ThunkAction<void, IAppState, null, Action<string>> => {
    return (dispatch: Dispatch) => {
        dispatch(runQAOnDistributionPoolsRequest())
        var distributionModel = DistributionDetailsMapper.mapStateToDistribution(distribution, true)
        JobService.runQAOnDistributionPools(distributionModel, undoAllocation)
            .then((res) => {
                if (res.status !== 200 || !res.data.success) {
                    res.response.data.messages = res.response.data.messages.map(message => message.replace("Status BadRequest - ", ""));
                    dispatch(runQAOnDistributionPoolsFailure(res.response.data));
                }
                else {
                    dispatch(runQAOnDistributionPoolsSuccess(res.data));
                }
            })
            .catch(err => {
                dispatch(runQAOnDistributionPoolsFailure(err));
            })
    }
}